<section>
  <div>
    <h2 class="h4 my-3">User Registration Approval Requests</h2>
    <p-table [value]="pendingApprovals" [columns]="cols" [paginator]="true" [alwaysShowPaginator]="false" [rows]="rows" [loading]="loadingApprovals"  (sortFunction)="customSort($event)" [customSort]="true" responsiveLayout="scroll" [autoLayout]="true">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col">Action</th>
          <th *ngFor="let column of columns" [pSortableColumn]="column.field" scope="col">
            {{column.header}}<p-sortIcon [field]="column.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">
        <tr>
          <th scope="row">
            <fieldset>
              <legend class="visually-hidden">Approve or Deny User</legend>
              <div class="form-check">
                <input class="form-check-input" type="radio" [attr.id]="'approve'+rowIndex" name="{{rowIndex}}" value="Approved" [(ngModel)]="rowData.ENESS_REF_ApprovalHistory.Status" (change)="onApproveChange(rowData)">
                <label class="form-check-label" [attr.for]="'approve'+rowIndex">
                  Approve
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" [attr.id]="'deny'+rowIndex" name="{{rowIndex}}" value="Denied" [(ngModel)]="rowData.ENESS_REF_ApprovalHistory.Status" (change)="onApproveChange(rowData)">
                <label class="form-check-label" [attr.for]="'deny'+rowIndex">
                  Deny
                </label>
              </div>
            </fieldset>
          </th>
          <td *ngFor="let col of columns" [ngSwitch]="col.field">
            <span *ngSwitchCase="'CreatedOn'">{{ (rowData.ENESS_REF_ApprovalHistory.ModifiedOn == null ? rowData.ENESS_REF_ApprovalHistory.CreatedOn : rowData.ENESS_REF_ApprovalHistory.ModifiedOn) | utcToLocal:'MM/dd/yyyy  HH:mm'}}</span>             
            <span *ngSwitchCase="'ATFFieldDivision'">{{rowData.ATFFieldDivision ? rowData.ATFFieldDivision.FieldDivisionName : '' }}</span>
            <span *ngSwitchCase="'FieldDivisionGroups'">{{(rowData.ENESS_XREF_ApplicationUserFDGroup && rowData.ENESS_XREF_ApplicationUserFDGroup[0] && rowData.ENESS_XREF_ApplicationUserFDGroup[0].ENESS_REF_IntelligenceReportATFReferralGroups) ? rowData.ENESS_XREF_ApplicationUserFDGroup[0].ENESS_REF_IntelligenceReportATFReferralGroups.GroupName : '' }}</span>
            <span *ngSwitchCase="'ENESS_REF_Agency'">{{rowData.ENESS_REF_Agency ? rowData.ENESS_REF_Agency?.AgencyName : '' }}</span>
            <span *ngSwitchCase="'ENESS_REF_UserType'">{{rowData.ENESS_REF_UserType.UserTypeDsiaplyName}}</span>
            <div *ngSwitchCase="'Roles'">
              <div *ngFor="let role of rowData.Roles">
                {{role.Role.Name}}
              </div>
            </div>
            <span *ngSwitchDefault>{{rowData[col.field]}}</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <th scope="row" [attr.colspan]="columns.length + 1">
            No approval requests found.
          </th>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
<section>
  <div>
    <h2 class="h4 my-3">User Access Change Requests</h2>
    <p-table #changeReq [value]="pendingChangeRequests" [columns]="cols" [paginator]="true" [rows]="rows" [alwaysShowPaginator]="false" (sortFunction)="customSort($event)" [customSort]="true" [loading]="loadingChangeReq"  responsiveLayout="scroll" [autoLayout]="true">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col">Action</th>
          <th *ngFor="let column of columns" [pSortableColumn]="column.field" scope="col">
            {{column.header}}<p-sortIcon [field]="column.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in descending order"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-changeReq let-rowIndex="rowIndex" let-columns="columns">
        <tr>
          <th scope="row">
            <fieldset>
              <legend class="visually-hidden">Approve or Deny User</legend>
              <div class="form-check">
                <input class="form-check-input" type="radio" [attr.id]="'changeApprove'+rowIndex" name="changeRequest{{rowIndex}}" value="Approved" [(ngModel)]="changeReq.Status" (change)="onApproveRequest(changeReq)">
                <label class="form-check-label" [attr.for]="'changeApprove'+rowIndex">
                  Approve
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" [attr.id]="'changeDeny'+rowIndex" name="changeRequest{{rowIndex}}" value="Denied" [(ngModel)]="changeReq.Status" (change)="onApproveRequest(changeReq)">
                <label class="form-check-label" [attr.for]="'changeDeny'+rowIndex">
                  Deny
                </label>
              </div>
            </fieldset>            
          </th>
          <td *ngFor="let col of columns" [ngSwitch]="col.field">
            <span *ngSwitchCase="'CreatedOn'">{{changeReq[col.field] | utcToLocal:'MM/dd/yyyy  HH:mm'}}</span>
            <span *ngSwitchCase="'ATFFieldDivision'">{{changeReq.ATFFieldDivision ? changeReq.ATFFieldDivision.FieldDivisionName : '' }}</span>
            <span *ngSwitchCase="'FieldDivisionGroups'">{{changeReq.FieldDivisionGroups ? changeReq.FieldDivisionGroups.GroupName : '' }}</span>
            <ng-container *ngSwitchCase="'ENESS_REF_Agency'">
              <span aria-hidden="true" pTooltip="{{ changeReq.ENESS_REF_Agency ? changeReq.ENESS_REF_Agency.AgencyName : '' }}">{{changeReq.ENESS_REF_Agency  && changeReq.ENESS_REF_UserType.UserTypeDsiaplyName == 'State and Local LE' ? changeReq.ENESS_REF_Agency.AgencyName : '' }}</span>
              <span class="visually-hidden">{{changeReq.ENESS_REF_Agency?.AgencyName}}</span>
            </ng-container>
            <span *ngSwitchCase="'ENESS_REF_UserType'">{{changeReq.ENESS_REF_UserType.UserTypeDsiaplyName}}</span>
            <div *ngSwitchCase="'Roles'">
              {{ changeReq.Role.Name}}
            </div>
            <span *ngSwitchDefault>{{changeReq[col.field]}}</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <th scope="row" [attr.colspan]="columns.length + 1">
            No access change requests found.
          </th>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
<aside>
  <p-sidebar [(visible)]="openApprovalCommentsForm" (onHide)="closeCommentSidebar()" position="right" [blockScroll]="true" styleClass="p-sidebar-lg" [showCloseIcon]="false" [dismissible]="false">
    <ness-approval-comment [data]="deniedApproval" (approvalSubmitted)="approvalSubmitted($event)" (closeForm)="closeCommentsForm($event)"></ness-approval-comment>
  </p-sidebar>
</aside>
